import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/AdminLayout";
import { OrdersTable } from "@/components/OrdersTable";
import { OrderDetailDialog } from "@/components/OrderDetailDialog";
import { NewOrderDialog } from "@/components/NewOrderDialog";
import { api, errMsg } from "@/lib/api";

const TABS = ["all", "pending", "confirmed", "ready", "completed", "cancelled"];

export default function Orders() {
  const [tab, setTab] = useState("all");
  const [orders, setOrders] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [creating, setCreating] = useState(false);

  const load = useCallback(() => {
    api.get("/admin/orders", { params: tab === "all" ? {} : { status: tab } }).then((r) => setOrders(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [tab]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <PageHeader eyebrow="Sales" title="Orders">
        <Button onClick={() => setCreating(true)} className="gap-2" data-testid="orders-new-button"><Plus className="h-4 w-4" />New order</Button>
      </PageHeader>
      <div className="mb-6 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`orders-tab-${t}`}
            className={`rounded-full border px-4 py-1.5 text-sm capitalize transition-colors ${tab === t ? "border-emerald-500 bg-emerald-500/10 text-emerald-300" : "border-border text-muted-foreground hover:text-foreground"}`}>
            {t}
          </button>
        ))}
      </div>
      <OrdersTable orders={orders} onOpen={setOpenId} />
      <OrderDetailDialog orderId={openId} onClose={() => setOpenId(null)} onChanged={load} />
      <NewOrderDialog open={creating} onClose={() => setCreating(false)} onCreated={load} />
    </div>
  );
}
